import { keyframes, styled } from "styled-components";

const skeletonLoading = keyframes`
  from {
    background-color: #c8c8db;
  }
  to {

    background-color: #ededf3;

  }
`;

export const Card = styled.div`
  border-radius: 2rem;
  position: relative;
  background: #fff;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%; /* Fleksibilna širina unutar grida */
  aspect-ratio: 300 / 354; /* Postavlja proporcije širine i visine */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  animation: ${skeletonLoading} 0.6s linear infinite alternate;

  @media (max-width: 335px) {
    width: 90%; /* Fleksibilna širina za vrlo male ekrane */
    aspect-ratio: auto; /* Osigurava da se proporcije prilagode */
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 4rem;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding: 4rem;

  > * {
    flex: 1 1 calc(25% - 20px); /* Održava 4 kolone */
    max-width: calc(25% - 20px); /* Sprečava prekoračenje */
    transition: all 0.3s ease-in-out;
  }

  /* Kada ima samo jedan proizvod */
  > *:only-child {
    flex: 1 1 70%;
    max-width: 400px;
    min-width: 400px;
  }

  @media (max-width: 2800px) {
    > * {
      flex: 1 1 calc(25% - 120px); /* 3 kolone za manje ekrane */
      max-width: calc(25% - 120px);
    }

    > *:only-child {
      flex: 1 1 70%;
      max-width: 400px;
      min-width: 400px;
    }
  }

  @media (max-width: 2500px) {
    > * {
      flex: 1 1 calc(25% - 20px); /* 3 kolone za manje ekrane */
      max-width: calc(25% - 20px);
    }

    > *:only-child {
      flex: 1 1 70%;
      max-width: 350px;
      min-width: 350px;
    }
  }

  @media (max-width: 1716px) {
    > * {
      flex: 1 1 calc(33.33% - 20px); /* 3 kolone za manje ekrane */
      max-width: calc(33.33% - 20px);
    }

    > *:only-child {
      flex: 1 1 80%; /* Proširuje karticu na srednjim ekranima */
      max-width: 300px;
      min-width: 300px;
    }
  }

  @media (max-width: 1185px) {
    > * {
      flex: 1 1 calc(50% - 20px); /* 2 kolone za još manje ekrane */
      max-width: calc(50% - 20px);
    }

    > *:only-child {
      flex: 1 1 80%;
      max-width: 250px;
      min-width: 250px;
    }
  }

  @media (max-width: 580px) {
    > * {
      flex: 1 1 100%; /* 1 kolona za najmanje ekrane */
      max-width: 100%;
    }

    > *:only-child {
      flex: 1 1 90%;
      max-width: 200px;
      min-width: 200px;
    }
  }

  @media (max-width: 340px) {
    > * {
      flex: unset; /* 1 kolona za najmanje ekrane */
      max-width: 100%;
      width: 30rem;
      height: 35rem;
    }
    > *:only-child {
      flex: 1 1 90%;
      max-width: 200px;
      min-width: 200px;
    }
  }
`;

export const CardProductName = styled.span`
  width: 100px;
  height: 10px;
  border-radius: 1rem;
  animation: ${skeletonLoading} 0.6s linear infinite alternate;
`;

export const ProductInfo = styled.div`
  padding: 1.5rem 2rem;
  border-radius: 1rem 1rem 2rem 2rem;
  background: #fff;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  min-height: 7.3rem;
  box-shadow: 0px -5px 4px 0px rgba(0, 0, 0, 0.05);
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Price = styled.span`
  width: 65px;
  height: 8px;
  border-radius: 10px;
  animation: ${skeletonLoading} 0.6s linear infinite alternate;
`;
